import * as Types from 'src/actions/project/download-document/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';

const FileDownload = require('react-file-download');

export interface DownloadDocumentAttempt extends Action {
  type: Types.DOWNLOAD_DOCUMENT_ATTEMPT;
  payload: number;
}

export interface DownloadDocumentSuccess extends Action {
  type: Types.DOWNLOAD_DOCUMENT_SUCCESS;
}

export interface DownloadDocumentFailure extends Action {
  type: Types.DOWNLOAD_DOCUMENT_FAILURE;
  payload: number;
}

export type DownloadDocumentAction = DownloadDocumentAttempt | DownloadDocumentSuccess | DownloadDocumentFailure | File;

export interface DownloadDocumentThunk extends ThunkAction<Promise<DownloadDocumentAction>, RootState, undefined> {
}

export const downloadDocumentAttempt: ActionCreator<DownloadDocumentAttempt> = (documentId: number) => ({
  type: Types.DOWNLOAD_DOCUMENT_ATTEMPT,
  payload: documentId
});

export const downloadDocumentSuccess: ActionCreator<DownloadDocumentSuccess> = () => ({
  type: Types.DOWNLOAD_DOCUMENT_SUCCESS,
});

export const downloadDocumentFailure: ActionCreator<DownloadDocumentFailure> = (documentId: number) => ({
  type: Types.DOWNLOAD_DOCUMENT_FAILURE,
  payload: documentId
});

export const downloadDocument: ActionCreator<DownloadDocumentThunk> = (
  document: string,
  id: number,
  download: boolean
): DownloadDocumentThunk => {

  return (dispatch: Dispatch<RootState>): Promise<DownloadDocumentAction> => {
    dispatch(downloadDocumentAttempt(id));

    return ApiClient.file.get(document)
      .then((response: AxiosResponse<File>): DownloadDocumentSuccess => {
        if (download) {
          const name = response.headers['content-disposition'].split('filename=')[1];
          FileDownload(response.data, name);
        } else {
          const fileBlob: File = response.data;
          const file = new Blob([fileBlob], {type: 'application/pdf'});
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }
        return dispatch(downloadDocumentSuccess());
      }).catch((e: {}): DownloadDocumentFailure => {
        return dispatch(downloadDocumentFailure(id));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/project/download-document/DownloadDocument.actions.tsx